import { createContext } from "react";

const SegmentosContext = createContext();

export default SegmentosContext;
